import { Link } from "react-router-dom";
import { ShieldHalf } from "lucide-react";
import { company, solutions } from "../../mock";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#05071F] border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 text-white">
          <ShieldHalf className="w-6 h-6 text-cyan-400" />
          <span className="font-heading font-semibold tracking-tight text-lg">{company.name}</span>
        </div>
        <p className="mt-4 text-sm text-slate-400 max-w-sm leading-relaxed">{company.tagline}</p>
        <p className="mt-4 text-sm text-slate-500">{company.location} · {company.serving}</p>
      </div>
      <div>
        <h5 className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-4">Solutions</h5>
        <ul className="space-y-2">
          {solutions.map((s) => (
            <li key={s.title}>
              <Link to={`/solutions/${s.slug}`} className="text-sm text-slate-400 hover:text-white transition-colors">{s.title}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h5 className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-4">Contact</h5>
        <ul className="space-y-2 text-sm text-slate-400">
          <li><a href={`mailto:${company.contactEmail}`} data-testid="footer-email-link" className="hover:text-white transition-colors">{company.contactEmail}</a></li>
          <li>{company.website}</li>
          <li>{company.location}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <p className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-xs text-slate-600">
        © {new Date().getFullYear()} {company.legalName}. All rights reserved.
      </p>
    </div>
  </footer>
);
